export default "__VITE_ASSET__Cqn9hyzO__"